module.exports = __webpack_public_path__ + "static/bottomRightAbout-1ec2408e0eeedec1416fa0bf24566fdb.png";